
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form11";
const form11State = namespace("Form11");

import Form11ProcessHeader from "@/components/process/Form11/components/Form11ProcessHeader.vue";
import Form11 from "@/components/process/Form11/components/pdf/Form11.vue"

import { form11StatusInfoType } from '@/types/Information/Form11';

@Component({
    components:{
        Form11ProcessHeader,
        Form11
    }
})
export default class PreviewForm11 extends Vue {

    @form11State.State
    public currentOrderMultipleJusticesId: string;

    stepsCompleted = {} as form11StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form11" }); 
    }
}
